import { CdkPortalOutlet } from '@angular/cdk/portal';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { XAxisComponent as NgxChartsXAxisComponent } from '@swimlane/ngx-charts';
import { Orientation } from '../graphs/models/orientation.enum';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'g[qmg-charts-x-axis]',
    templateUrl: './x-axis.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class XAxisComponent extends NgxChartsXAxisComponent {
   @Input() referenceLines: any[];

   @Input() showRefLines: boolean = true;

   @Input() showRefLabels: boolean = true;

   @Input() referenceLinesOutlet?: CdkPortalOutlet;

   readonly Orientation = Orientation;
}
